import {DataFormField} from "types/models/input-field-type";
import {FIELD_TYPE} from "types/enums";
import Icons from "assets/icons";
import Icon from "@ant-design/icons";
import React from "react";
import {Space, Button, Typography, Row} from "antd";

const {RADIO_BUTTON, INPUT, AUTO_COMPLETE, COMBO_BOX} = FIELD_TYPE;

const labelCol = {xs: 6, md: 6, lg: 6};
const wrapperCol = {xs: 18, md: 18, lg: 18};
const css = {xs: 24, sm: 24, md: 24, lg: 24, xl: 24};

export const FieldsLens1: Array<DataFormField> = [
  {
    name: ["rightJsonValue", "LENS", "Hình thái"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Hình thái",
    radioButtons: [
      {
        label: "Trong",
        value: "Trong",
        span: 6,
      },
      {
        label: "Đục thủy tinh thể",
        value: "Đục thủy tinh thể",
        span: 6,
      },
      {
        label: "Thủy tinh thể nhân tạo",
        value: "Thủy tinh thể nhân tạo",
        span: 6,
      },
      {
        label: "Không có thủy tinh thể",
        value: "Không có thủy tinh thể",
        span: 6,
      },
    ],
  },
  {
    label: "Vị trí",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["rightJsonValue", "LENS", "Vị trí"],
    radioButtons: [
      {
        label: "Trung tâm",
        value: "Trung tâm",
        span: 8,
      },
      {
        label: "Lệch trung tâm",
        value: "Lệch trung tâm",
        span: 8,
      },
      {
        label: "Lệch một phần",
        value: "Lệch một phần",
        span: 8,
      },
    ],
  },
  {
    name: ["rightJsonValue", "LENS", "Kích thước"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Kích thước",
    radioButtons: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 6,
      },
      {
        label: "Sưng nề",
        value: "Sưng nề",
        span: 6,
      },
      {
        label: "Tiêu",
        value: "Tiêu",
        span: 6,
      },
      {
        label: "Nhỏ",
        value: "Nhỏ",
        span: 6,
      },
    ],
  },
  {
    name: ["rightJsonValue", "LENS", "Phân loại LOCS"],
    type: RADIO_BUTTON,
    css: {xs: 6, sm: 6, md: 6, lg: 6, xl: 6},
    labelCol: {xs: 24, sm: 24, md: 24},
    label: "Phân loại LOCS",
  },
  {
    name: ["rightJsonValue", "LENS", "NS"],
    type: AUTO_COMPLETE,
    css: {xs: 6, sm: 6, md: 6, lg: 6, xl: 6},
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "NS",
    options: [
      {value: "sel", label: "sel"},
      {value: "1", label: "1"},
      {value: "2", label: "2"},
      {value: "3", label: "3"},
      {value: "4", label: "4"},
      {value: "5", label: "5"},
    ],
  },
  {
    name: ["rightJsonValue", "LENS", "C"],
    type: AUTO_COMPLETE,
    css: {xs: 6, sm: 6, md: 6, lg: 6, xl: 6},
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "C",
    options: [
      {value: "sel", label: "sel"},
      {value: "1", label: "1"},
      {value: "2", label: "2"},
      {value: "3", label: "3"},
      {value: "4", label: "4"},
      {value: "5", label: "5"},
    ],
  },
  {
    name: ["rightJsonValue", "LENS", "P"],
    type: AUTO_COMPLETE,
    css: {xs: 6, sm: 6, md: 6, lg: 6, xl: 6},
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "P",
    options: [
      {value: "sel", label: "sel"},
      {value: "1", label: "1"},
      {value: "2", label: "2"},
      {value: "3", label: "3"},
      {value: "4", label: "4"},
      {value: "5", label: "5"},
    ],
  },
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["rightJsonValue", "LENS", "Ghi chú"],
    css: css,
    labelCol: {xs: 6, md: 6, lg: 6},
    wrapperCol: {xs: 18, md: 18, lg: 18},
  },
  {
    label: "show",
    type: INPUT,
    name: ["rightJsonValue", "LENS", "show"],
    hide: true,
  },
];

export const FieldsLens2: Array<DataFormField> = [
  {
    name: ["leftJsonValue", "LENS", "Hình thái"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Hình thái",
    radioButtons: [
      {
        label: "Trong",
        value: "Trong",
        span: 6,
      },
      {
        label: "Đục thủy tinh thể",
        value: "Đục thủy tinh thể",
        span: 6,
      },
      {
        label: "Thủy tinh thể nhân tạo",
        value: "Thủy tinh thể nhân tạo",
        span: 6,
      },
      {
        label: "Không có thủy tinh thể",
        value: "Không có thủy tinh thể",
        span: 6,
      },
    ],
  },
  {
    label: "Vị trí",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "LENS", "Vị trí"],
    radioButtons: [
      {
        label: "Trung tâm",
        value: "Trung tâm",
        span: 8,
      },
      {
        label: "Lệch trung tâm",
        value: "Lệch trung tâm",
        span: 8,
      },
      {
        label: "Lệch một phần",
        value: "Lệch một phần",
        span: 8,
      },
    ],
  },
  {
    name: ["leftJsonValue", "LENS", "Kích thước"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Kích thước",
    radioButtons: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 6,
      },
      {
        label: "Sưng nề",
        value: "Sưng nề",
        span: 6,
      },
      {
        label: "Tiêu",
        value: "Tiêu",
        span: 6,
      },
      {
        label: "Nhỏ",
        value: "Nhỏ",
        span: 6,
      },
    ],
  },
  {
    name: ["leftJsonValue", "LENS", "Phân loại LOCS"],
    type: RADIO_BUTTON,
    css: {xs: 6, sm: 6, md: 6, lg: 6, xl: 6},
    labelCol: {xs: 24, sm: 24, md: 24},
    label: "Phân loại LOCS",
  },
  {
    name: ["leftJsonValue", "LENS", "NS"],
    type: AUTO_COMPLETE,
    css: {xs: 6, sm: 6, md: 6, lg: 6, xl: 6},
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "NS",
    options: [
      {value: "sel", label: "sel"},
      {value: "1", label: "1"},
      {value: "2", label: "2"},
      {value: "3", label: "3"},
      {value: "4", label: "4"},
      {value: "5", label: "5"},
    ],
  },
  {
    name: ["leftJsonValue", "LENS", "C"],
    type: AUTO_COMPLETE,
    css: {xs: 6, sm: 6, md: 6, lg: 6, xl: 6},
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "C",
    options: [
      {value: "sel", label: "sel"},
      {value: "1", label: "1"},
      {value: "2", label: "2"},
      {value: "3", label: "3"},
      {value: "4", label: "4"},
      {value: "5", label: "5"},
    ],
  },
  {
    name: ["leftJsonValue", "LENS", "P"],
    type: AUTO_COMPLETE,
    css: {xs: 6, sm: 6, md: 6, lg: 6, xl: 6},
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "P",
    options: [
      {value: "sel", label: "sel"},
      {value: "1", label: "1"},
      {value: "2", label: "2"},
      {value: "3", label: "3"},
      {value: "4", label: "4"},
      {value: "5", label: "5"},
    ],
  },
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["leftJsonValue", "LENS", "Ghi chú"],
    css: css,
    labelCol: {xs: 6, md: 6, lg: 6},
    wrapperCol: {xs: 18, md: 18, lg: 18},
    // suffix: (
    //   <Icon
    //     rev={0}
    //     style={{fontKích thước: "24px"}}
    //     component={Icons.file as React.ForwardRefExoticComponent<any>}
    //   />
    // ),
  },
  {
    label: "show",
    type: INPUT,
    name: ["leftJsonValue", "LENS", "show"],
    hide: true,
  },
];
